module.exports = __webpack_public_path__ + "img/new-version-banner.b4ac12e6.png";